import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
interface LinkCellProps {
    content: ReactNode;
    url: string;
    underline?: boolean;
    state?: unknown;
    className?: string;
}
export const LinkCell: React.FC<LinkCellProps> = ({ content, url, underline, state, className }) => {
    return (
        <Link
            className={`${className ?? 'text-info'} fw-bolder`}
            style={{
                fontSize: '.875rem',
                ...(!underline ? { textDecoration: 'none' } : { textDecoration: 'underline' })
            }}
            to={url}
            state={state}
        >
            {content}
        </Link>
    );
};